import { render, staticRenderFns } from "./StatistiquesAccount.vue?vue&type=template&id=0dab3fc4"
import script from "./StatistiquesAccount.vue?vue&type=script&lang=js"
export * from "./StatistiquesAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports